import { Injectable, OnDestroy } from '@angular/core';
import { FormService } from './form.service';
import { FormConstants } from 'app/constants/form.constants';
import { AllCaseAttachmentsModel } from 'app/models/all-case-attachments.model';
import { FormRequiredDocumentsMapping } from 'app/constants/document.constants';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormValidationService implements OnDestroy {
  private invalidFormFieldsSubscription: Subscription;
  private sectionValidityMap: Map<string, boolean> = new Map();

  constructor(private formService: FormService) {
    this.invalidFormFieldsSubscription = this.formService.getInvalidFormFieldsUpdate().subscribe(invalidFields => {
        this.populateInvalidSectionMap(invalidFields);
    });
   }

   ngOnDestroy(): void {
    this.invalidFormFieldsSubscription.unsubscribe();
  }

  get formSectionsInfo() {
    return FormConstants.FORM_SECTION_NAME_MAP;
  }

  public resetSectionValidityMap() {
    this.formSectionsInfo.forEach((entry) => {
      this.sectionValidityMap.set(entry.value, true);
    });
  }

  public sectionHasError(sectionName: string): boolean {
    if(!this.formService.isShowingErrorSections) {
      return false;
    }

    let isValid = this.sectionValidityMap.get(sectionName);
    return isValid !== undefined ? !isValid : true;
  }

  private populateInvalidSectionMap(invalidFields: string[]) {
    this.resetSectionValidityMap();
    let invalidSections = new Set<string>();
    if(invalidFields) {
      
      invalidFields.forEach(fieldName => {
        let key = FormConstants.getKeyByValue(FormConstants.REQUIRED_FIELD_TO_SECTION_NAME_MAP, fieldName);
        
        if(key) {
          invalidSections.add(key);
        }
      });
      invalidSections.forEach(section => {
        this.sectionValidityMap.set(section, false);
      });
    }
    this.sectionValidityMap.set(`Applicant Information`, this.isApplicantInfoPageValid);
    this.sectionValidityMap.set(`Upload Documents`, this.hasAllRequiredDocuments);
    this.sectionValidityMap.set(`Payment Information`, (this.isPaymentComplete && this.doesFormHaveProofOfPayment));
  }

  get isApplicantInfoPageValid(): boolean {
    return this.formService.isApplicantInfoPageValid();
  }
  
  get hasAllRequiredDocuments(): boolean {
    return FormRequiredDocumentsMapping.hasAllRequiredDocumentsAttached(this.formService.getCurrentUsanFormValue().get('formType')?.value, this.allCaseAttachments);
  }

  get allCaseAttachments(): AllCaseAttachmentsModel {
    return this.formService.getAllCaseAttachmentsValue();
  }

  get isPaymentComplete(): boolean {
    return this.formService.isPaymentCompleted();
  }
  
  get doesFormHaveProofOfPayment(): boolean {
    return this.formService.doesFormHaveProofOfPayment();
  }

}
